import { Fragment } from "react";

import { Contact } from "@components/__templates__/EventsDetail/EventsDetail";
import IconGlobal from "../../../public/image/svg/global.svg";
import IconCall from "../../../public/image/svg/phone.svg";

const ContactsSection = (props: { contacts: Contact[] }) => {
  const { contacts } = props;
  return (
    <dl>
      {contacts
        .filter((contact) => !!contact.fields?.fullName)
        .map((contact, index) => (
          <Fragment key={`contact-${index}`}>
            <dt>{contact.fields?.fullName}</dt>
            <dd>
              {!!contact.fields?.email && (
                <p className="flex items-center gap-2">
                  <IconGlobal aria-hidden />
                  {contact?.fields?.email}
                </p>
              )}
              {!!contact?.fields?.phoneNumber && (
                <p className="flex items-center gap-2">
                  <IconCall aria-hidden />
                  <a href={`tel:${contact?.fields?.phoneNumber}`}>
                    {contact?.fields?.phoneNumber}
                  </a>
                </p>
              )}
            </dd>
          </Fragment>
        ))}
    </dl>
  );
};

export default ContactsSection;
